module.exports = __webpack_public_path__ + "img/technologies_img.4199cc7a.png";